export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			alerts: {
				common: {
					dash: '—',
					na: 'n/a',
					general: 'General',
					unassigned: 'Unassigned graphs',
					refresh: 'Refresh',
					dismiss: 'Dismiss',
				},
				overview: {
					title: 'Alerts Overview',
					subtitle: 'Projects, locations, hubs, and modules with their latest states.',
					refreshError: 'Failed to refresh alert data.',
					loadError: 'Failed to load alert data.',
				},
				graphs: {
					title: 'Graph Alerts',
					subtitle: 'Graphs currently in alert or warning state.',
					table: {
						graph: 'Graph / Equation',
						location: 'Location',
						status: 'Status',
						lastWarn: 'Last Warn',
						lastAlert: 'Last Alert',
						noData: 'No alerts detected across graphs.',
					},
					status: {
						alert: 'alert',
						warning: 'warning',
						ok: 'ok',
					},
				},
				matrixGraphs: {
					title: 'Current Graph States',
					filterLabel: 'Only show alerts & warnings',
					projectLabel: 'Project',
					allProjects: 'All projects',
				},
				widget: {
					title: 'Alarms',
					tabAlarms: 'Alarms',
					tabFlags: 'Missing data',
					alert: 'Alert',
					warn: 'Warning',
					ok: 'OK',
					empty: 'No alarms configured',
					filter: 'Filter alarms…',
					groups: {
						alert: 'Alarms',
						warn: 'Warnings',
						noData: 'Too few readings',
						ok: 'OK',
					},
					noMatches: 'No matching alarms',
					counted: '{shown} of {total}',
					states: {
						alert: 'Alert',
						warnPreAlert: 'Warn + pre-alert',
						preAlert: 'Pre-alert',
						warn: 'Warning',
						preWarn: 'Pre-warning',
						ok: 'OK',
						'no data': 'Too few readings',
						unknown: 'Not analyzed',
					},
					noReadings: 'No intervals recorded yet',
					stateComputed: 'State calculated {ago} ({date})',
					stateTooFew: '{have} of {need} units judged — the alarm needs {need} in a row',
					whyTitle: 'Too few readings',
					whyCompact: '{have} of {need} {unit} within the last {span}',
					whyNewest: 'newest reading {ago}',
					whyNewestUnit: 'newest interval {range}',
					whyUnitDeep: 'readings',
					whyUnitTimekey: 'intervals of {interval}',
					spanDays: '{n} days',
					spanHours: '{n} hours',
					spanMinutes: '{n} minutes',
					whyPending: 'stored: {state} ({ago}), updates with the next run',
					ruleDeep: 'Alarm after {n} readings outside the limits · deep resolution',
					ruleTimekey: 'Alarm after {n} intervals of {interval} outside the limits · {aggregate}',
					ruleExplain: 'Judged per equation, on its own readings. In interval mode the interval still running is greyed out and does not count yet.',
					aggregateMinmax: 'min/max',
					aggregateAvg: 'average',
					readingCountOne: '1 reading',
					readingCountMany: '{n} readings',
					statAvg: 'Avg',
					detailFrom: 'From',
					detailTo: 'To',
					detailAt: 'Recorded',
					detailAge: 'Age',
					detailMin: 'Minimum',
					detailAvg: 'Average',
					detailMax: 'Maximum',
					detailCount: 'Readings',
					detailValue: 'Value',
					detailLevel: 'Judgement',
					levels: {
						ok: 'within limits',
						warn: 'warning range',
						alert: 'alarm range',
						ignored: 'ignored (outside the ignore range)',
					},
					stateNever: 'Not calculated yet',
					thresholdWarn: 'Warning {range}',
					thresholdAlert: 'Alert {range}',
					since: 'since {date}',
					loadError: 'Readings could not be loaded',
				},
				matrixUsers: {
					headers: {
						phone: 'Phone',
						role: 'Role',
						email: 'Email',
						sms: 'SMS',
						contact: 'Contact',
						warn: 'Warn',
						alert: 'Alert',
					},
					footerSelectAll: 'Select all',
					empty: 'No custom graphs match the current filter.',
					unknownUser: 'Unknown user',
				},
				matrixGraphTable: {
					headers: {
						graph: 'Graph / Equation',
						state: 'State',
						lastState: 'Last State',
						projectNumber: 'Project #',
						project: 'Project',
						location: 'Location',
						lastCase: 'Last Case',
						sentAt: 'Sent at',
						ok: 'OK',
						preWarn: 'PreWarn',
						warn: 'Warn',
						warnPreAlert: 'WarnPreAlert',
						preAlert: 'PreAlert',
						alert: 'Alert',
					},
					noProject: 'No project',
					noData: 'No graph alert data available.',
				},
				byUser: {
					status: 'Status',
					analyze: 'Analyze Data',
					send: 'Send Messages',
					projectLabel: 'Project',
					allProjects: 'All projects',
					selectProject: 'Select a project',
					onlyAlerts: 'Only graphs with alerts or warnings',
					usersEquations: '{users} users • {equations} equations',
					unsaved: 'Unsaved changes',
					save: 'Save',
					modalTitle: 'Alert Status Overview',
					modalAlt: 'Status analysis',
					confirmSend: 'Send warning emails to recipients?',
					toastAnalyzeSuccess: 'Alert data recalculated successfully.',
					toastAnalyzeError: 'Failed to analyze alert data.',
					toastSendSuccess: 'Messages queued successfully.',
					toastSendError: 'Failed to send messages.',
					toastSaveSuccess: 'Alert settings saved.',
					toastSaveError: 'Failed to save alert settings.',
				},
				projectUsers: {
					summary: '{users} user(s) • {equations} equation(s)',
					equation: 'Graph / Equation',
					notifications: 'Notifications',
					addUserPlaceholder: 'Add user...',
					remove: 'Remove',
					removeTitle: 'Remove User',
					confirmRemove: 'Remove {name} from alerts?',
					unsaved: 'Unsaved changes',
					save: 'Save',
					saveSuccess: 'Alert settings saved.',
					saveError: 'Failed to save alert settings.',
					noEquations: 'No equations configured for this project.',
				},
			},
		},
		de: {
			alerts: {
				common: {
					dash: '—',
					na: 'k. A.',
					general: 'Allgemein',
					unassigned: 'Nicht zugewiesene Graphen',
					refresh: 'Aktualisieren',
					dismiss: 'Schließen',
				},
				overview: {
					title: 'Alarmübersicht',
					subtitle: 'Projekte, Standorte, Hubs und Module mit ihren letzten Zuständen.',
					refreshError: 'Alarmdaten konnten nicht aktualisiert werden.',
					loadError: 'Alarmdaten konnten nicht geladen werden.',
				},
				graphs: {
					title: 'Graph-Alarme',
					subtitle: 'Graphen, die aktuell im Alarm- oder Warnzustand sind.',
					table: {
						graph: 'Graph / Gleichung',
						location: 'Standort',
						status: 'Status',
						lastWarn: 'Letzte Warnung',
						lastAlert: 'Letzter Alarm',
						noData: 'Keine Alarme für Graphen erkannt.',
					},
					status: {
						alert: 'Alarm',
						warning: 'Warnung',
						ok: 'OK',
					},
				},
				matrixGraphs: {
					title: 'Aktuelle Graph-Zustände',
					filterLabel: 'Nur Alarme & Warnungen anzeigen',
					projectLabel: 'Projekt',
					allProjects: 'Alle Projekte',
				},
				widget: {
					title: 'Alarme',
					tabAlarms: 'Alarme',
					tabFlags: 'Fehlende Daten',
					alert: 'Alarm',
					warn: 'Warnung',
					ok: 'OK',
					empty: 'Keine Alarme konfiguriert',
					filter: 'Alarme filtern …',
					groups: {
						alert: 'Alarme',
						warn: 'Warnungen',
						noData: 'Zu wenige Messwerte',
						ok: 'OK',
					},
					noMatches: 'Keine passenden Alarme',
					counted: '{shown} von {total}',
					states: {
						alert: 'Alarm',
						warnPreAlert: 'Warnung + Vor-Alarm',
						preAlert: 'Vor-Alarm',
						warn: 'Warnung',
						preWarn: 'Vor-Warnung',
						ok: 'OK',
						'no data': 'Zu wenige Messwerte',
						unknown: 'Nicht ausgewertet',
					},
					noReadings: 'Noch keine Intervalle erfasst',
					stateComputed: 'Zustand berechnet {ago} ({date})',
					stateTooFew: '{have} von {need} beurteilten Einheiten — der Alarm braucht {need} hintereinander',
					whyTitle: 'Zu wenige Messwerte',
					whyCompact: '{have} von {need} {unit} in den letzten {span}',
					whyNewest: 'jüngster Messwert {ago}',
					whyNewestUnit: 'jüngstes Intervall {range}',
					whyUnitDeep: 'Messwerten',
					whyUnitTimekey: 'Intervallen à {interval}',
					spanDays: '{n} Tagen',
					spanHours: '{n} Stunden',
					spanMinutes: '{n} Minuten',
					whyPending: 'gespeichert: {state} ({ago}), wird beim nächsten Lauf angeglichen',
					ruleDeep: 'Alarm nach {n} Messwerten außerhalb der Grenzen · Deep-Auflösung',
					ruleTimekey: 'Alarm nach {n} Intervallen à {interval} außerhalb der Grenzen · {aggregate}',
					ruleExplain: 'Beurteilt wird je Gleichung anhand ihrer eigenen Messwerte. Im Intervall-Modus ist das laufende Intervall ausgegraut und zählt noch nicht.',
					aggregateMinmax: 'Min/Max',
					aggregateAvg: 'Durchschnitt',
					readingCountOne: '1 Messwert',
					readingCountMany: '{n} Messwerte',
					statAvg: 'Ø',
					detailFrom: 'Von',
					detailTo: 'Bis',
					detailAt: 'Zeitpunkt',
					detailAge: 'Alter',
					detailMin: 'Minimum',
					detailAvg: 'Durchschnitt',
					detailMax: 'Maximum',
					detailCount: 'Messwerte',
					detailValue: 'Wert',
					detailLevel: 'Bewertung',
					levels: {
						ok: 'innerhalb der Grenzen',
						warn: 'im Warnbereich',
						alert: 'im Alarmbereich',
						ignored: 'ignoriert (außerhalb des Ignorier-Bereichs)',
					},
					stateNever: 'Noch nicht berechnet',
					thresholdWarn: 'Warnung {range}',
					thresholdAlert: 'Alarm {range}',
					since: 'seit {date}',
					loadError: 'Messwerte konnten nicht geladen werden',
				},
				matrixUsers: {
					headers: {
						phone: 'Telefon',
						role: 'Rolle',
						email: 'E-Mail',
						sms: 'SMS',
						contact: 'Kontakt',
						warn: 'Warn',
						alert: 'Alarm',
					},
					footerSelectAll: 'Alle auswählen',
					empty: 'Keine Custom-Graphen passen zum aktuellen Filter.',
					unknownUser: 'Unbekannter Benutzer',
				},
				matrixGraphTable: {
					headers: {
						graph: 'Graph / Gleichung',
						state: 'Status',
						lastState: 'Letzter Status',
						projectNumber: 'Projekt #',
						project: 'Projekt',
						location: 'Standort',
						lastCase: 'Letzter Fall',
						sentAt: 'Gesendet am',
						ok: 'OK',
						preWarn: 'PreWarn',
						warn: 'Warn',
						warnPreAlert: 'WarnPreAlert',
						preAlert: 'PreAlert',
						alert: 'Alarm',
					},
					noProject: 'Kein Projekt',
					noData: 'Keine Graph-Alarmdaten verfügbar.',
				},
				byUser: {
					status: 'Status',
					analyze: 'Daten analysieren',
					send: 'Nachrichten senden',
					projectLabel: 'Projekt',
					allProjects: 'Alle Projekte',
					selectProject: 'Projekt auswählen',
					onlyAlerts: 'Nur Graphen mit Alarm oder Warnung',
					usersEquations: '{users} Benutzer • {equations} Gleichungen',
					unsaved: 'Ungespeicherte Änderungen',
					save: 'Speichern',
					modalTitle: 'Alarmstatus-Übersicht',
					modalAlt: 'Statusanalyse',
					confirmSend: 'Warn-E-Mails an Empfänger senden?',
					toastAnalyzeSuccess: 'Alarmdaten erfolgreich neu berechnet.',
					toastAnalyzeError: 'Alarmdaten konnten nicht analysiert werden.',
					toastSendSuccess: 'Nachrichten wurden in die Warteschlange gestellt.',
					toastSendError: 'Nachrichten konnten nicht gesendet werden.',
					toastSaveSuccess: 'Alarm-Einstellungen gespeichert.',
					toastSaveError: 'Alarm-Einstellungen konnten nicht gespeichert werden.',
				},
				projectUsers: {
					summary: '{users} Benutzer • {equations} Gleichung(en)',
					equation: 'Graph / Gleichung',
					notifications: 'Benachrichtigungen',
					addUserPlaceholder: 'Benutzer hinzufügen...',
					remove: 'Entfernen',
					removeTitle: 'Benutzer entfernen',
					confirmRemove: '{name} von Alarmen entfernen?',
					unsaved: 'Ungespeicherte Änderungen',
					save: 'Speichern',
					saveSuccess: 'Alarm-Einstellungen gespeichert.',
					saveError: 'Alarm-Einstellungen konnten nicht gespeichert werden.',
					noEquations: 'Keine Gleichungen für dieses Projekt konfiguriert.',
				},
			},
		},
	},
}
